import axios from 'axios';
import moment from "moment";
const CancelToken = axios.CancelToken;

import env from '../../config/env';
import { vue } from "../main";
import { getLoginComponent, getMyHeader, errorMessage, GlobalLoading, Constants, User } from "../utils";
var { Validator, Message, Patterns } = require('@shangyang/validator');
var { DateUtils } = require('@shangyang/utils');
var { TimeoutError, NetworkError, BadRequestError } = require('@shangyang/error');

Date.prototype.toJSON = function(){
    console.log('----------toJSON String')
    return moment(this).format("YYYY-MM-DDTHH:mm:ss:msZ");;
};

Date.prototype.toISOString = function () {
    console.log('-----------toISO String')
    return moment(this).format("YYYY-MM-DDTHH:mm:ss:msZ");
};

/**
 * 注意，重试的话，必须显式的赋值 retriable = true 才会生效，否则不会生效。因为有些关键的请求，只允许提交一次。
 * @param config
 * @return {Promise<AxiosResponse<any>>}
 */
export async function request(config) {

    // 默认重试 3 次，尽快失败，避免用户切换频道的过程中，容易串频道（上一次没有响应的在用户切换后响应了，覆盖了当前频道的内容）。
    const MAX_RETRIES = 3;

    // 设置最大的默认重试的次数
    if(config.retriable !== undefined && config.retriable !== null && config.retriable === true){
        if(config.maxRetries === undefined || config.maxRetries === null){
            config.maxRetries = MAX_RETRIES;
        }
    }

    // TODO create a cancel token https://github.com/axios/axios#cancellation
    //  想了想，这个需求 HCF-346 目前并不是很紧急，暂时不做
    const source = CancelToken.source();
    config.cancelToken = source.token;
    // console.log(`cancel token: ${JSON.stringify(source.token, null, 4)}`);

    // 1. 创建 axios 的实例
    const instance = axios.create({
        baseURL: env.BACKEND_BASE_URL(),
        timeout: 8000,   // 单位是 ms，因为现在大部分核心请求都由重试逻辑，因此这个值不宜设置得过大。
        // crossDomain: true
    })

    // @deprecated 不再使用 cookies 登录了，因此 CORS cookies 不需要了。
    // if(process.env.NODE_ENV === 'development'){
    //     config.withCredentials = true
    //     console.log('CORS, withCredentials has been set within dev env only');
    // }

    // 2. 实现基本的拦截功能
    // 2.1. 请求拦截
    instance.interceptors.request.use(config => {
        config.headers['Content-Type'] = `application/json`; // 用这种方式往 headers 中追加一个属性
        // ----- 重要，以下记录如何在跨域请求（Hybrid app 访问的方式）下允许自定义 req HEADER -----
        // 重要，因为 Hybrid app 是跨域请求访问的，必须要在服务器端允许 Version 头字段的访问和写入，现在是通过 nginx 配置的，否则服务器报
        // 错不允许带 Version 字段的非法 HEADER 请求访问。详情参考《huocool 生产部署 01》【支持 hybrid app 跨域访问】小节中的描述。
        config.headers['Version'] = `${env.VERSION}`
        // config.headers['X-From'] = `version-${env.VERSION}@huocool.com`; // app version
        // FIXME 只需要取一次，然后放到 Vuex 中即可。或者说 localStory 本身就是内存中获取，很快，不用担心?
        const access_token = User.token;
        console.log('access token retrieved from local stoarge get:', access_token);
        if (access_token) {
            config.headers['Authorization'] =`Bearer ${access_token}`;
            console.log(`the token ${access_token} has been injected into the header for validation`);
        }
        return config;
    }, err => {
        console.error(err);
        throw err;
    });

    // 2.2. 响应拦截
    // 2.2.1 对错误进行了统一的拦截处理，因此，其他异步调用的地方不用处理错误了。
    instance.interceptors.response.use(res => {
        // do some transformation with the response as below,
        console.log('response', res, res.status, res.statusText);
        if( res.data.token ){
            let token = res.data.token;
            User.token = token;
            console.log(`token ${token} received and saved it into local storage`);
        }
        return res.data
    }, err => {
        console.error('remote call get error', JSON.stringify(err, null, 4));
        if (err.toString().indexOf('timeout') >= 0) {
            console.log(`Timeout error caught, enwrap the error as TimeoutError`);
            GlobalLoading.stop();  // HCF-320, route spinner do NOT disappears.
            throw new TimeoutError('网络超时，请稍后再试!');
        } else if (err.toString().indexOf('Network Error') >=0 ) {
            console.log('network error caught, enwrap it as NetworkError')
            GlobalLoading.stop();  // HCF-320, route spinner do NOT disappears.
            throw new NetworkError('当前没有网络，请检查你的网络连接');
        } else if (err.response !== undefined) { // 如果是超时错误，是没有 response 属性的。
            if(err.response.status !== undefined){
                switch (err.response.status){
                    case 403:
                        // 用户试图访问授权页面，但检测到未授权，因此返回 403 请求，需要用户认证。常见的情况是，用户登录后，打开了两个窗口，在一个窗口
                        // 中登出了，然后在另外一个页面中访问授权内容，此时，403，需要用户重新授权。或者用户在页面停留时间太长，session Timeout
                        getMyHeader().isSignedIn = false; // 不再显示登入图标（头像）
                        getLoginComponent().show(); // 显示登录窗口
                        getLoginComponent().error = Message.WARN_REQUEST_RE_SIGNIN; // 在 global error 中显示
                        errorMessage(Message.WARN_REQUEST_RE_SIGNIN); // 使用 message 提示窗口中显示
                        // 同时将 user 重置为 null，让前端 api-security#CacheApiSecurity 能够发挥作用。这种情况只有在 signed in session 失效后会起到作用
                        vue.$store.commit('setUser', null);
                        User.removeToken(); // 清除无效的 token
                        break;
                    case 404:
                        // TODO handle the 404 error commonly
                        vue.$router.push('/404');
                        break;
                    case 401:
                        // 这个错误是 jwt 抛出来的 UnauthorizedError: jwt malformed；清除本地不合法的 token
                        User.removeToken(); // 清除无效的 token
                        console.log('the invalid token get removed');
                    case 400:
                        // 无效的请求
                        throw new BadRequestError();
                }
            }
        }

        // 本来想，在这里以弹出 message 的方式警告用户出现错误。但是想了想，一个页面那么多的请求，难保某一个出错，如果遇到一个无关紧要的也要
        // 弹出 error message 显然不合理；因此，这里将异常继续抛出，由客户端组件自行判断是否需要捕获处理。
        // Message.error(....)
        throw err;
    })

    /**
     * 1. transformResponse 在传递给 then/catch 前，允许修改响应数据。这里就是自定义 serialize response data 的地方了。
     * 2. 该转换是为了避免 JSON parse 自动的将 UTC date string 转换成本地时区。使用 moment 进行转换。
     *    背景：因为 Mongodb 只能存储 utc date，为了维护的方便，将 locale date 存储为 utc date，而 axios 所使用的 JSON parser 在将
     *    utc timestamp string -> 转换为 local datetime 的时候，会自动的进行时区转换即转换为本地时区，导致我无法得到准确的时间。因此，这
     *    一步的目的就是禁止 JSON parser 自动的将 utc timestamp string 解析为 local datetime 而是依然解析为 utc datetime.
     * @param data, the response raw data.
     * @return {*}
     */
    config.transformResponse = function (data) {
        if (data===undefined || data===null || data === '') return data;  // can NOT transfer.
        // 如果请求返回的类型是 responseType = 'stream' 那么返回的就是一个二进制文本数据，通过 /\ufffd/.test(data) 判断该文本是否是二进制数据
        // BUG, 不能使用 /\ufffd/.test(data) 去判断返回的是否是一个二进制串，会误判！在生产环境下获取分页信息的时候，将 utf 字符串识别为了二进制串
        // if (/\ufffd/.test(data) === true || data instanceof Blob){
        if( data instanceof Blob ) { // TODO how to judgement the bindary chars?
            console.log("requests, transform responose, the data is 'binary' or 'Blob', do NOT parse, direct return");
            return data;
        } else {
            if (typeof (data) === 'string') { // update, only the string type needs to convert.
                // console.log('transfer the raw data:', data);
                JSON.dateParser = function (key, value) {
                    if (typeof value === 'string') {
                        if (Patterns.ISO_DATE_PATTERN.exec(value)) { // huocool 返回到前端的都是 ISO date format（YYYY-MM-DDTHH:mm:ss.SSSZ） 日期。
                            // console.log('json date parser to parse the date, key:', key, 'value:', value);
                            // 1. 务必写成最标准的格式并且将时区加上：'YYYY-MM-DDTHH:mm:ss-08:00'，否则 Safari 得不到正确的值。
                            // 2. 下面这段代码的逻辑是，moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ') 同样会将 utc date -> local date，然后 format 转换回 utc date.
                            // @deprecated，试验如下，发现无论怎么设置，他都会转成 UTC + 8
                            // >>> value = "2021-07-18T21:48:52.787+00:00"
                            // >>> moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss-08:00');
                            // '2021-07-19T05:48:52-08:00'
                            // return moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss-08:00');
                            return DateUtils.adjust(new Date(value));
                        }
                        return value;
                    }
                    return value;
                }
                data = JSON.parse(data, JSON.dateParser);
                // console.log('after transfer, the data:', data);
            }
        }
        return data;
    }

    // 3. 发送真正的网络请求，返回的本身就是一个 Promise 对象，如果 retriable 则捕获 TimeoutError 来重试
    if(config.retriable !== undefined && config.retriable !== null && config.retriable === true){
        let retried = -1;  // 第一次是正常请求，不算 retry，因此将值设置为 -1
        while(true){
            try{
                // 发起 request 请求，若成功则 return Response.
                return await instance(config);
            }catch(error){
                // 之前写成了 !error instanceof TimeoutError 导致了 infinite retry..... 记住了不能这么写。
                if(!(error instanceof TimeoutError)){
                    throw error;
                }else{
                    retried ++;
                    console.log(`Timeout Error caught, try to retry the request of config
                    ${JSON.stringify(config, null, 4)}, so far retried ${retried} out of total retriable
                    ${config.maxRetries}`);
                    if(retried > config.maxRetries && config.maxRetries !== -1){  // 如果是 -1 表示重试无限多次。
                        console.log(`already retried ${config.maxRetries} times, throw out the timeout error`)
                        throw error; // 抛出错误终止循环，错误的封装在响应拦截中处理
                    }
                }
            }
        }
    }else{
        return await instance(config)
    }

}



// WEBPACK FOOTER //
// ./src/data/requests.js